import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';

import { Button } from './Button';
import device from '../utils/device';

const Container = styled.div`
  position: relative;
  text-align: center;

  p,
  li {
    font-size: 17px;
  }
  p {
    line-height: 1.8rem;
  }

  margin: 0 0 1rem 0;

  @media ${device.desktop} {
    width: 60vw;
    margin: 1rem auto 1rem;
  }
`;

const Row = styled.div`
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

const Column = styled.div`
  flex-basis: 100%;
  @media ${device.desktop} {
    flex-basis: 50%;
  }
`;

const ColumnInner = styled.div`
  padding: 0 1rem;
`;

const PreTitle = styled.h1`
  color: ${({ theme }) => theme.colors.textDark};
  font-weight: 600;
  line-height: 1.5;
  font-size: 1.8rem;
  margin-bottom: 1.2rem
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.textDark};
  font-weight: 700;
  width: 100%;
  font-size: 1.5rem;
`;

const PositionedButton = styled(Button)`
  display: inline-block;
  margin: 0 auto 2rem;
`;

const CourseOverview = () => {
  const theme = useContext(ThemeContext);
  return (
    <Container>
      <PositionedButton
        to="#payment-options"
        variant="solid"
        size="SM"
        color={theme.colors.actionPrimary}
      >
        Click here to register
      </PositionedButton>
      <Row>
        <div>
            <PreTitle>
            Continue the Trauma & Awakening journey with this groundbreaking, in-depth program hosted by Alex Howard and taught by Dr Gabor Maté and Hameed (A H Almaas).
            </PreTitle>
            <p>
            The program brings together Gabor and Hameed’s wisdom in a way that goes beyond theories and ideas, and offers practical tools and exercises you can put into action immediately. 
            </p>
        </div>
      </Row>
    </Container>
  );
};

export default CourseOverview;
